import React, { useEffect } from 'react';
import { useEffectOnce } from 'react-use';
import { connect } from 'react-redux';

import { isIE, isFirefox, isMobile } from 'react-device-detect';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import { Helmet } from 'react-helmet';
import store from '../../redux/store';
import translationsObject from '../../constants/Lang';

import config from '../../config';
import { newEle } from '../../utils/Helper';

const TopApp = ({ ...props }) => {
  const { match = {}, siteConfig } = props;
  const { data = {} } = siteConfig || {};
  const { css_style_block = '', js_script_block = '', defaultLanguage, favicon } = data;

  useEffectOnce(() => {
    syncTranslationWithStore(store);
    store.dispatch(loadTranslations(translationsObject));
    window.locationServiceEndpoint = config.locationServiceEndPoint;
    setTimeout(() => {
      genCookiesContentEle();
    }, 1000);
  });

  useEffect(() => {
    const curLang = match.params.locale || defaultLanguage;
    const HKTDCLangChange = new CustomEvent(config.customEvent.langChange, {
      detail: {
        language: curLang,
      },
    });
    document.dispatchEvent(HKTDCLangChange);
    store.dispatch(setLocale(curLang));
    if (window.reloadPopup) {
      window.reloadPopup(curLang); // EU Consent, reload when lang is changed
    }
  }, [match.params.locale]);

  const genCookiesContentEle = () => {
    newEle('cookieConsentCSS', config.scriptUrl.cookieConsentCSS, document.head, 'stylesheet');
    newEle(
      'cookieContentHKTDCCSS',
      config.scriptUrl.cookieContentHKTDCCSS,
      document.head,
      'stylesheet',
    );
    newEle('cookieConsentJS', config.scriptUrl.cookieConsentJS, document.body, 'script');
    setTimeout(() => {
      newEle(
        'cookieConsentHKTDCJS',
        config.scriptUrl.cookieConsentHKTDCJS,
        document.body,
        'script',
      );
    }, 100);
  };

  const HelmetByBrowser = (
    <>
      {isIE && <Helmet htmlAttributes={{ class: 'is-ie' }} />}
      {isFirefox && <Helmet htmlAttributes={{ class: 'is-firefox' }} />}
      {isMobile && <Helmet htmlAttributes={{ class: 'is-Mobile' }} />}
    </>
  );

  return (
    <>
      {HelmetByBrowser}
      <Helmet>
        {css_style_block && (
          <style name="customGlobalStylesheet" type="text/css">
            {css_style_block}
          </style>
        )}
        {js_script_block && <script name="customGlobalmJsScript">{js_script_block}</script>}
        {favicon && <link id="favicon" rel="shortcut icon" href={favicon} />}
      </Helmet>
    </>
  );
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  siteConfig: state.siteConfig,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(TopApp);

export { TopApp as TopAppComponent }; // <- For component Unit Test
export default connectStore;
